import classNames from "classnames";
import { formatTime, formatWithLocale } from "@hudson/ui/lib/date_fns_locale";
import useContent from "@lib/use_content";
import useConfig from "@lib/use_config";

interface FlightParams {
  className?: string;
  flight: be.Flight;
  showDay?: boolean;
  timeFormat?: be.TimeFormat;
}

function Flight({ className = "", flight, showDay, timeFormat }: FlightParams): JSX.Element | null {
  const { data } = useContent(["beRessummaryFlightSectionTitle"]);
  const { data: cfgData } = useConfig(["hideTerminal", "customerRequestMode"]);

  if (!flight.airline && !flight.flightNumber && !flight.terminal && !flight.flightTime)
    return null;
  return (
    <div className={classNames(className)}>
      <h3 className="text-sm">{data?.content.beRessummaryFlightSectionTitle}</h3>
      <p className="text-sm text-gray-600">
        {flight.airline} {flight.flightNumber}{" "}
        {cfgData?.config.hideTerminal ? null : flight.terminal}
      </p>

      {flight.flightTime && cfgData?.config.customerRequestMode !== 2 && (
        <p className="text-sm text-gray-600 flex">
          <span className="">
            {formatTime(flight?.flightTime, timeFormat)}
            {showDay && <> ({formatWithLocale(flight?.flightTime, "EEEE")})</>}
          </span>
        </p>
      )}
    </div>
  );
}

export default Flight;
